import React, { ReactPortal, ReactNode } from 'react'
import { createPortal } from 'react-dom'
import { makeStyles } from '@material-ui/core/styles'

interface Props {
  children: ReactNode
}

const useStyles = makeStyles(() => ({
  container: {
    zIndex: 9999,
    position: 'relative'
  }
}))

export const Portal = ({ children }: Props): ReactPortal => {
  const classes = useStyles()
  const modalRoot = document.getElementById('modal-root')

  if (!modalRoot) return null

  return createPortal(
    <div className={classes.container}>{children}</div>,
    modalRoot
  )
}
